// 中文注释：全局状态管理，包含用户信息与权限
import { createStore } from "vuex";
import apiClient from "../services/apiClient";

// 用户信息类型定义 - 与后端UserInfo schema保持一致
type UserInfo = {
  id: number;
  username: string;
  display_name?: string;
  role: string;
  is_active: boolean;
  last_login?: string;
  created_at: string;
  updated_at: string;
};

export default createStore({
  state: {
    user: null as UserInfo | null, // 当前登录用户信息
    audioUnlocked: false,
  },
  getters: {
    // 获取当前用户信息
    getUser(state) {
      return state.user;
    },
    // 获取当前用户角色
    getUserRole(state) {
      return state.user?.role || "";
    },
    // 判断是否已登录 - 通过用户信息和token判断
    isLoggedIn(state) {
      return !!state.user && state.user.is_active;
    },
    // 判断当前用户是否拥有指定权限点
    // 用法：this.$store.getters.hasPermission('xxx')
    hasPermission: (state) => (permission: string) => {
      // 动态引入权限映射，避免循环依赖
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      const { ROLE_PERMISSIONS } = require("../types/permission");
      const role = state.user?.role || "";
      const permissions = ROLE_PERMISSIONS[role] || [];
      return permissions.includes(permission);
    },
    getAudioUnlocked(state) {
      return !!state.audioUnlocked;
    },
  },
  mutations: {
    // 设置用户信息
    setUser(state, user: UserInfo) {
      state.user = user;
    },
    // 清除用户信息
    clearUser(state) {
      state.user = null;
    },
    setAudioUnlocked(state, flag: boolean) {
      state.audioUnlocked = !!flag;
    },
  },
  actions: {
    // 登录后保存用户信息
    saveUser({ commit }, user: UserInfo) {
      commit("setUser", user);
    },
    // 退出登录
    logout({ commit }) {
      commit("clearUser");
    },
    // 获取用户信息
    async fetchUserInfo({ commit }) {
      try {
        const response = await apiClient.get("/auth/userinfo");
        // 修复：适配后端统一返回结构，setUser 只接收 userInfo 数据
        commit("setUser", response.data.data);
        return response.data.data;
      } catch (error) {
        commit("clearUser");
        throw error;
      }
    },
  },
  modules: {},
});
